var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoDemoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "30mm",
    height: "2.5mm",
    viewBox: "0 0 30 2.5",
    id: "svg8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-82.172761,-88.653543)"
  }, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontSize: "2.6px",
      lineHeight: 1.5,
      fontFamily: "Roboto",
      InkscapeFontSpecification: "Roboto",
      strokeWidth: 0.264583
    },
    x: 86.934525,
    y: 90.699936,
    id: "text12"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan10",
    x: 86.934525,
    y: 90.599936,
    fill: "#fff",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontFamily: "'Roboto'",
      strokeWidth: 0.264583
    }
  }, "Demo App")), /*#__PURE__*/React.createElement("path", {
    id: "rect14",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.233104,
      strokeDasharray: "2.79725, 2.79725",
      strokeDashoffset: 0.279725
    },
    d: "m 314.35156,335.21094 c -2.09236,0 -3.77734,1.68497 -3.77734,3.77734 0,2.09237 1.68498,3.77539 3.77734,3.77539 h 7.22656 c 2.09237,0 3.77735,-1.68302 3.77735,-3.77539 0,-2.09237 -1.68498,-3.77734 -3.77735,-3.77734 z M 315,335.88867 h 5.92969 c 1.71652,0 3.09765,1.38309 3.09765,3.09961 0,1.71652 -1.38113,3.09766 -3.09765,3.09766 H 315 c -1.71652,0 -3.09766,-1.38114 -3.09766,-3.09766 0,-1.71652 1.38114,-3.09961 3.09766,-3.09961 z",
    transform: "scale(0.26458333)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDemoWhite);
export default __webpack_public_path__ + "static/media/logo-demo-white.e341aa1c68e4a93acd8f43270ef0de59.svg";
export { ForwardRef as ReactComponent };